import { Enviroment } from '../../_config/constants/enviroment-v2.constant';
import { AxiosAdapter } from '../../_config/v2/adapters/axios/axios.adapter';
import { Http } from '../../_config/v2/adapters/axios/axios.protocols';
import { ENVIROMENT } from '../../v2-config/constants/enviroment.constant';

export class Service {
	async uploadRecipe(file) {
		const formData = new FormData();
		formData.append('file', file);

		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.FUNCTION_MIGRATION_PHAROL}/resources/${Enviroment.COUNTRY}`,
			data: formData,
		}).request();
	}

	// async createMagistralQuotation(payload) {
	// 	return new AxiosAdapter({
	// 		method: Http.POST,
	// 		url: `${Enviroment.FUNCTION_QUOTATION}/CL`,
	// 		data: payload,
	// 	}).request();
	// }

	async createMagistralQuotation(payload) {
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral`,
			data: payload,
		}).request();
	}

	async sendQuotationRequest(payload) {
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.FUNCTION_EMAIL}/${Enviroment.COUNTRY}/quotation-request`,
			params: { root_pharmacy: ENVIROMENT.ROOT_PHARMACY },
			data: payload,
		})
			.request()
			.then((response) => response)
			.catch((error) => error);
	}

	async sendQuotationRequestToPharmacies(payload) {
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.FUNCTION_EMAIL}/${Enviroment.COUNTRY}/quotation-request/pharmacies`,
			params: { root_pharmacy: ENVIROMENT.ROOT_PHARMACY },
			data: payload,
		})
			.request()
			.then((response) => response)
			.catch((error) => error);
	}

	async getPharmacy() {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_MIGRATION_PHAROL}/pharmacy-locals/country/${Enviroment.COUNTRY}/pharmacy/${Enviroment.ROOT_PHARMACY}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
}
